"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let JobRunView = class JobRunView extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    onClick(...args) {
        const [ev] = args;
        const event = ev.originalEvent;
        if (event.detail === 3) {
            const selection = window.getSelection();
            const range = document.createRange();
            range.selectNodeContents(event.target);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }
    item;
    onItem(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("item");
    }
    ux;
    dataMembers = ['ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                ux: null,
            },
        };
    }
    get result_text() {
        if (this.loaded) {
            return (this.item.result_data && this.item.result_data.message) || this.item.result_text;
        }
        return null;
    }
    get details() {
        if (this.loaded) {
            return (this.item.result_data && this.item.result_data.details) || this.item.log;
        }
        return null;
    }
    async act_6917646200545441_script_7762_getActionArgs_value($event) {
        this.onClick($event);
    }
    async act_6917646200545441_script_7762_getActionArgs($event) {
        return {
            value: () => this.act_6917646200545441_script_7762_getActionArgs_value($event),
        };
    }
    async evh_6917646200545441_clickStop(event, scope) {
        return await this.actions.evh_6917646200545441_clickStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_6917646200545441_script_7762 = new core_1.actions.ScriptAction({
            actionArgs: this.act_6917646200545441_script_7762_getActionArgs,
            events: [],
        });
        const evh_6917646200545441_clickStop_7761 = new core_1.actions.EventHandlerImpl({
            action: act_6917646200545441_script_7762,
            event: "click.stop",
            displayName: "script",
        });
        const evh_6917646200545441_clickStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6917646200545441_clickStop_7761],
        });
        return {
            act_6917646200545441_script_7762,
            evh_6917646200545441_clickStop_7761,
            evh_6917646200545441_clickStop,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], JobRunView.prototype, "item", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('item'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], JobRunView.prototype, "onItem", null);
JobRunView = __decorate([
    (0, vue_property_decorator_1.Component)()
], JobRunView);
exports.default = JobRunView;
vue_property_decorator_1.Vue.component("JobRunView", JobRunView);
